import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_GOOGLE_FIREBASE_API_KEY,
    authDomain: "campusraccoons.firebaseapp.com",
  projectId: "campusraccoons",
  storageBucket: "campusraccoons.appspot.com",
  messagingSenderId: "741753923117",
  appId: "1:741753923117:web:b1f682a41ac3f6ca263aa4",
  measurementId: "G-0JP39JP51D"
  };

  const app = initializeApp(firebaseConfig);
  export const db = getFirestore(app); 